import type { MyWindow } from '@/types/window'
const GA_ID = 'G-F7HJLPGPS9'

export function initGoogleAnalytics() {
  //if (!window.location.href.includes("localhost")) {
  const script = document.createElement('script')
  script.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID)
  document.getElementsByTagName('head')[0]?.appendChild(script)
  ;(window as unknown as MyWindow).dataLayer = (window as unknown as MyWindow).dataLayer || []
  // @ts-expect-error: with types it doesn't work for some reason, but it works without
  gtag('js', new Date())
  // @ts-expect-error: with types it doesn't work for some reason, but it works without
  gtag('config', GA_ID, {
    send_page_view: false,
  })
  // @ts-expect-error: with types it doesn't work for some reason, but it works without
  gtag('event', 'page_view')

  // console.log("GA active with ID: " + GA_ID)
  //}
}

function gtag() {
  ;(window as unknown as MyWindow).dataLayer.push(arguments)
}
